export default "__VITE_ASSET__CsH7R34w__"